import React, { useState, useEffect } from 'react';
import Slider from './Slider';

function DataSlider({ district="0" }) {

  const [item, setItem] = useState({ colomename: [], count: [] });

  useEffect(() => {
    // Fetch Data from Backend API
    const fetchData = async () => {
      const response = await fetch(`https://checkmateelection.com/ramshinde/admin/card.php?district=${district}`);
      const jsonData = await response.json();
      setItem(jsonData);
    };

    fetchData();
    /*/
    const intervalId = setInterval(fetchData, 40000); // 20 seconds

    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId);
*/
  }, [district]);

  const titles = {
    "total_records":"एकूण नोंदी",
    "business_count": "उद्योजक",
    "business_percentage": "उद्योजक %",
    "government_employee_count":"शासकीय कर्मचारी",
    "government_employee_percentage":"शासकीय कर्मचारी %",
    "padadhikari_count":"पदाधिकारी ",
    "padadhikari_percentage":"पदाधिकारी  % "
  };

  return (
    <Slider>
  {
    item?.count?.length > 0 && item?.colomename?.map((columnName, index) => (
      <div key={index} className="card flex m-2 text-center" style={{ width: '10rem', height: '70px', fontSize: '12px' }}>
        <div className="card-header mt-0">
          <b style={{ fontSize: '15px', fontFamily: 'sans-serif' }}>
            {titles[columnName] || columnName} {/* Display title from `titles` if available */}
          </b>
          <p>{item.count[index]}</p> 
        </div>
      </div>
    ))
  }
</Slider>

  );
}

export default DataSlider;
